import axios from 'axios'

// TODO: refactor function name

export const claim = ({ event, code, signature }) => axios.post(`${process.env.REACT_APP_API_URI}/claim`, {
  event,
  code,
  sig: signature
})